// extracted by mini-css-extract-plugin
export default {"MasterBoxNoticias":"noticias_MasterBoxNoticias__4OZgc","Banner":"noticias_Banner__9ng-o","overlay":"noticias_overlay__KpeIG","Content":"noticias_Content__j-PZs"};